/* ============================================================
   Thema lesen, setzen, umschalten (Kopie aus lilasprojekte, SPEC §13.2).

   DUNKEL ist die Vorgabe (E9, „genau wie projekte") — hart, nicht über das System.
   Wer lieber hell arbeitet, schaltet einmal in der Kopfleiste um, und die Wahl bleibt.
   Die Katalogseiten bleiben in beiden Themen weiß: das Papier ist kein UI-Element.

   Der Schlüssel `kt.theme` muss mit public/theme.js übereinstimmen — dort steht
   derselbe Name, damit das Thema schon VOR dem ersten Anstrich sitzt.
   ============================================================ */
import { create } from "zustand";
import { load, save } from "./storage";

export type Theme = "dark" | "light";

/** Schlüssel in localStorage: `kt.theme`. MUSS mit public/theme.js übereinstimmen. */
export const THEME_KEY = "theme";

export const THEME_STANDARD: Theme = "dark";

/** Die zwei Werte, die auch in public/theme.js und index.html stehen. */
const THEME_COLOR: Record<Theme, string> = { dark: "#070707", light: "#faf7f5" };

export function readTheme(): Theme {
  const t = load<Theme | null>(THEME_KEY, null);
  if (t === "light" || t === "dark") return t;
  return THEME_STANDARD;
}

/** Setzt das Thema am Dokument — und NUR dort; gespeichert wird in setzen(). */
export function applyTheme(theme: Theme): void {
  const el = document.documentElement;
  el.classList.toggle("dark", theme === "dark");
  el.classList.toggle("light", theme !== "dark");
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", THEME_COLOR[theme]);
}

/* Ein winziger zustand-Speicher über denselben Werten: die Zuordnungsfarben (P6) und die Legenden
   müssen auf den Wechsel reagieren, und ein Wert, der nur am <html>-Element hängt,
   löst kein Neuzeichnen aus. */
interface ThemaZustand {
  thema: Theme;
  setzen(t: Theme): void;
  umschalten(): void;
}

const useThemaStore = create<ThemaZustand>((set, get) => ({
  thema: readTheme(),
  setzen(t) {
    applyTheme(t);
    save(THEME_KEY, t);
    set({ thema: t });
  },
  umschalten() {
    get().setzen(get().thema === "dark" ? "light" : "dark");
  },
}));

export function useTheme(): ThemaZustand {
  return useThemaStore();
}

export function aktuellesThema(): Theme {
  return useThemaStore.getState().thema;
}
